interface AddPatientNoteFooterProps {
    isSaving: boolean;
    canSave: boolean;
    saveLabel: string;
    onCancel: () => void;
    onSave: () => void;
}

/** Cancel + the primary save action, sized to the current selection
 *  ("Create note" / "Create N notes" - see saveLabel). */
export function AddPatientNoteFooter({
    isSaving,
    canSave,
    saveLabel,
    onCancel,
    onSave
}: AddPatientNoteFooterProps) {
    return (
        <div className="flex items-center justify-between px-5 py-3.5 border-t border-gray-100 bg-gray-50/50">
            <button
                onClick={onCancel}
                disabled={isSaving}
                className="text-sm font-medium text-gray-500 hover:text-gray-700 px-3 py-1.5 disabled:opacity-50"
            >
                Cancel
            </button>
            <button
                onClick={onSave}
                disabled={!canSave}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold transition-all ${
                    canSave
                        ? 'bg-gray-900 text-white hover:bg-black shadow-sm'
                        : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                }`}
            >
                {isSaving ? (
                    <>
                        <div className="w-3.5 h-3.5 rounded-full border-2 border-current/30 border-t-current animate-spin" />
                        Saving
                    </>
                ) : (
                    saveLabel
                )}
            </button>
        </div>
    );
}
